import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { SubscriptionType } from './subscription-type.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class SubscriptionTypeService extends AbstractEntityService {

    protected resourceUrl = 'api/subscription-types';
    private resourceSearchUrl = 'api/_search/subscription-types';
    protected resourceCountUrl = 'api/_search/count/subscription-types';

    constructor(protected http: HttpClient) {super(http); }

    create(subscriptionType: SubscriptionType): Observable<SubscriptionType> {
        let copy: SubscriptionType = Object.assign({}, subscriptionType);
        return this.http.post<SubscriptionType>(this.resourceUrl, copy).map((res: SubscriptionType) => {
            return res;
        });
    }

    update(subscriptionType: SubscriptionType): Observable<SubscriptionType> {
        let copy: SubscriptionType = Object.assign({}, subscriptionType);
        return this.http.put<SubscriptionType>(this.resourceUrl, copy).map((res: SubscriptionType) => {
            return res;
        });
    }

    find(id: number): Observable<SubscriptionType> {
        return this.http.get<SubscriptionType>(`${this.resourceUrl}/${id}`).map((res: SubscriptionType) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<SubscriptionType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<SubscriptionType[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<SubscriptionType[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<SubscriptionType[]>>(this.resourceSearchUrl, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type.service.ts